// extracted by mini-css-extract-plugin
export default {"positional-grid":"positional-grid","positional-tile":"positional-tile","positional-value":"positional-value","positional-label":"positional-label"};